import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export const VisitReferralsDetails = ({ referrals, referralsRef, handleFileDownload }) => {
  if (!Array.isArray(referrals) || referrals.length === 0) return null;

  return (
    <div ref={referralsRef}>
      {referrals.map((referral, index) => (
        <Card key={index} className="mb-4">
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">Siuntimas</Heading>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <span>Data: </span>
              <span>
                {new Date(Date.parse(referral.date)).getUTCHours() === 0 ? (
                  <Moment utc format="YYYY-MM-DD">
                    {Date.parse(referral.date)}
                  </Moment>
                ) : (
                  <Moment utc format="YYYY-MM-DD HH:mm">
                    {Date.parse(referral.date)}
                  </Moment>
                )}
              </span>
            </div>

            <div>
              <span>Gydytojas: </span>
              <span>
                {referral.doctorSpeciality} - {referral.doctorName} {referral.doctorSurname}
              </span>
            </div>

            <div>
              <span>Diagnozė: </span>
              <span>{referral.diagnosis}</span>
            </div>

            <div>
              <span>Kokiam specialistui siuntimas parašytas: </span>
              <span>{referral.specialist}</span>
            </div>

            <div>
              <span>Siuntimo tikslas:</span>
              {referral.purpose?.split(/\r?\n|<br\/>/).map((text, i) => (
                <div key={i}>{text}</div>
              ))}
            </div>

            <div>
              <span>Galioja iki: </span>
              <span>
                {new Date(Date.parse(referral.validUntil)).getUTCHours() === 0 ? (
                  <Moment utc format="YYYY-MM-DD">
                    {Date.parse(referral.validUntil)}
                  </Moment>
                ) : (
                  <Moment utc format="YYYY-MM-DD HH:mm">
                    {Date.parse(referral.validUntil)}
                  </Moment>
                )}
              </span>
            </div>

            {referral.file?.guid && (
              <div>
                <Button
                  variant="light"
                  onClick={() => {
                    const fileName = `${referral.doctorSpeciality}-${referral.doctorName} ${referral.doctorSurname} ${moment(referral.date).format('YYYY-MM-DD')}`;
                    handleFileDownload(
                      'Referral',
                      fileName,
                      referral.file.type,
                      referral.file.guid
                    );
                  }}
                >
                  <Download />
                  Atsisiųsti PDF
                </Button>
              </div>
            )}
          </CardContent>
          <CardFooter />
        </Card>
      ))}
    </div>
  );
};
